export default "__VITE_ASSET__4ba4ff30__"